import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../../assets/styles/components/instrument/market-set-mobile.scss'
import marketsetIcon from '@/assets/images/icons/mobiles/editwatchlist_icon_editgroup@2x.png'
import TabHeader from '@/components/TabHeader/TabHeader';
import { mobileSubLayoutAction } from '@/actions/app/mobileSubLayout.action';
import { Converter } from '@/helpers/functions'
import Topicon from '@/assets/images/icons/mobiles/editwatchlist_icon_top@2x.png'
import { WINVEST_PARAMS_JSON_FLAG } from '@/constants/win-vest'
import { userActions } from '@/actions/user';
import { REFRESH_DATA } from '@/constants/app';
import { SERVICES_RESP } from '@/configurations';
import NoRow from '@/components/DataTable/CustomNoRow';
import { LOADING_TYPE } from '@/constants/app';
import LoadingLayer from '@/components/Spinner/LoadingLayer';


class MarketSet extends Component{
    constructor(props) {
        super(props)
        this.state={
            customTab:'',
            curretTanID:1,
            mainTabWidth:0,
            currentGroup:"",
            tabWidth:0,
            load:false
        }
    }

    render(){
        const { customTab , mainTabWidth , currentGroup , tabWidth , load } = this.state
        const { tabsWidth , language } = this.props
        
        return(
            <div className='market-set-container'>
              <LoadingLayer load={load} type={LOADING_TYPE.BIG_IMG} />
                <div className='market-set-tabhead'>
                    <TabHeader tabs={customTab} onChange={this.handleChangeWatchlistTab} justifyContent={tabWidth > mainTabWidth  ? 'space-between' : 'center'}/>
                    <img src={marketsetIcon} onClick={mobileSubLayoutAction.openManageCustomWatchlistGroup}></img>
                </div>
                <div className='market-set-content'>
                    <div className='rank-header'>
                        <div onClick={()=>this.sortWathlist('symbol')}>{language.common_symbol} </div>
                        <div style={{paddingRight:language.lang =='en_US' ? "20px" : '30px'}}>{language.market_topping} </div>
                    </div>
                    <div className='watchlist-list'>
                        {JSON.stringify(currentGroup.flaggings) != '[]' ? currentGroup.flaggings?.map((item,index)=>{
                            return(
                                <div className='list-item' key={index}>
                                    <div>
                                        <span style={{fontSize:'14px'}}>{item.name}</span>
                                        <span style={{fontSize:'12px'}}>{[Converter.mappingWebSocketMarket(item.market),item.id].join('.')}</span>
                                    </div>
                                    <img src={Topicon} onClick={()=>this.handleTopping(item, index)}></img>
                                </div>
                            )
                        })
                        : <NoRow style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '93%' , width :'100%'}} />
                        }
                    </div>
                </div>
            </div>
        )
    }

    initTab=()=>{
        const { watchlist } = this.props
        const { curretTanID } = this.state
        const { custom } = watchlist
        let customTab;
        this.setState({load:true})
        if(Array.isArray(custom)) {
            customTab = custom.reduce((acc, tmp, index) => {
              const id = index - 0 + 1
              acc.push({
                id,
                title: tmp.title,
                isActive: id === curretTanID,
                name: tmp.name,
                flaggings:tmp.flaggings
              })
              return acc
            }, [])
        }
        let mainTabWidth =document.getElementsByClassName('market-set-tabhead')[0].getElementsByClassName('main-tab')[0].clientWidth
        this.setState({customTab,mainTabWidth},()=>{
          setTimeout(() => {
            this.computedTabWidth()
            this.setState({load:false})
          }, 500);
        })
    }

    handleChangeWatchlistTab=(activetab)=>{
        if(activetab.main.flaggings){
            let sortFlaggings = activetab.main.flaggings.sort((a,b)=>{return b.weight - a.weight})
            activetab.main.flaggings = sortFlaggings
        }
        this.setState({currentGroup:activetab.main},()=>{
        })
    }

    handleTopping(item, index) {
        let { currentGroup } = this.state
        currentGroup.flaggings.splice(index, 1)
        currentGroup.flaggings.unshift(item)
        this.setState({ currentGroup }, () => {
          let items = []
          if (this.state.currentGroup.flaggings) {
            this.state.currentGroup.flaggings.forEach(item => {
              items.push(item.id + ":" + item.market)
            })
            const Pitem = items.join(',');
            const params = {
              [WINVEST_PARAMS_JSON_FLAG.KEY]: WINVEST_PARAMS_JSON_FLAG.VALUE,
              data: [
                {
                  name: currentGroup.name,
                  items: Pitem,
                }
              ]
            }
            this.props.manageWatchList(params, res => {
              this.handleResponse(res)
              
              this.props.handleRefreshTable()
            })
          }
        })
      }

      computedTabWidth=()=>{
        let tab = document.getElementsByClassName('market-set-tabhead')[0].getElementsByClassName('main-tab-item')
        let tabWidth = 0
        if(tab && tab.length){
          for(let i=0;i<tab.length;i++){
            tabWidth += tab[i].clientWidth
          }
        }
        this.setState({tabWidth})
      }

      handleResponse = (res, message) => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
            const { userInfo } = this.props
            this.props.getWatchlist({ uuid: userInfo.id }, response => {
                
            })
        } else {
            const errorMessage = res?.result ?? ''
            this.setState({ errorMessage,  isLoadingConfirm: false })
        }
    }

    componentDidMount(){
        const { watchlist, userInfo, markets } = this.props
        if (watchlist.custom ) {
            let sortFlaggings = watchlist.custom[0].flaggings?.sort((a,b)=>{return b.weight - a.weight})
            watchlist.custom[0].flaggings = sortFlaggings
            this.setState({ currentGroup: watchlist.custom[0] })
          }
        this.initTab()
    }

    componentDidUpdate(preProps){
        const { watchlist } = this.props
        if(preProps.watchlist.custom != watchlist.custom){
            this.initTab()
        }
    }
}








export default connect(
    state => ({
      language: state.app.language,
      watchlist: state.user.watchlist,
      userInfo: state.user.userInfo,
      markets: state.trade.markets,
      theme: state.app.theme,
    }),
    dispatch => ({
      addNewWatchlist: (p, c) => dispatch(userActions.addNewWatchlistAction(p, c)),
      deleteWatchlist: (p, c) => dispatch(userActions.deleteWatchlistAction(p, c)),
      getWatchlist: (p, c) => dispatch(userActions.getInstrumentWatchlistAction(p, c)),
      manageWatchList: (p, c) => dispatch(userActions.manageWatchlistAction(p, c)),
      toggleRefreshMarket: (p) => {
        dispatch({
          type: REFRESH_DATA.MARKET_ACTION,
          value: p
        })
      }
    }))(MarketSet)